import { useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';

import usePermission from 'routes/usePermission';

const useDashboardActions = (makeActionHandler: any, makeActionList: any, containerParams: any = EMPTY_OBJECT) => {
	const history = useHistory();
	const location = useLocation();
	const { app, showAlert } = useContext(AppContext);
	const { hasPermission } = usePermission();
	const getActionHandler = (action: any, params = EMPTY_OBJECT) => {
		return makeActionHandler(action, {
			...containerParams,
			...params,
			location,
			history,
			isGold: app.isGold,
			appName: app.appName,
			showAlert
		});
	};
	const getActionList = (params = EMPTY_OBJECT) => {
		const actionList = makeActionList({
			...containerParams,
			...params,
			history,
			appName: app.appName,
			isGold: app.isGold,
			hasPermission
		});
		const { addAction = EMPTY_OBJECT, submitAction = EMPTY_OBJECT, clearAction = EMPTY_OBJECT } = actionList;

		const modifiedActionList = { ...actionList };
		if (!addAction.isEnabled?.()) {
			modifiedActionList.addAction = null;
		}
		if (!submitAction.isEnabled?.()) {
			modifiedActionList.submitAction = null;
		}
		if (!clearAction.isEnabled?.()) {
			modifiedActionList.clearAction = null;
		}
		return modifiedActionList;
	};

	return {
		getActionHandler,
		getActionList
	};
};

export default useDashboardActions;
